if (!customElements.get('swiper-carousel')) {
  class Carousel extends HTMLElement {
    constructor() {
      super();

      this.showPagination = this.dataset.pagination === 'true' ? {
        clickable: true,
        el: '[data-pagination]',
        type: 'bullets',
        bulletElement: 'li',
        bulletActiveClass: this.dataset.bulletActiveClass || 'swiper-pagination-bullet-active',
        bulletClass: this.dataset.bulletClass || 'swiper-pagination-bullet'
      } : false;

      this.width = Number(this.dataset.width) || null;
    }

    connectedCallback() {
      if (window.Swiper) {
        this.init();
        return;
      }
      document.querySelector('[data-swiper-script]').addEventListener('load', () => this.init());
    }

    init() {
      const options = {
        a11y: {
          enabled: true,
          focusableElements: 'a, input, select, option, textarea, button, video, label',
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        autoHeight: true,
        autoplay: this.dataset.autoplay == 'true' ? { delay: this.dataset.delay || 3000} : false,
        pagination: this.showPagination,
        spaceBetween: Number(this.dataset.mobileSpaceBetween) || Number(this.dataset.spaceBetween) || 2,
        preventClicksPropagation: true,
        loop: false,
        width: this.width,
        slidesPerView: Number(this.dataset.mobileSlidesPerView) || 1,
        slidesPerGroup: Number(this.dataset.slidesPerScrollMobile) || 1,
        initialSlide: Number(this.dataset.initialSlide) || 0,
        centeredSlides: this.dataset.centeredMobile ? this.dataset.centeredMobile === 'true' : !!this.dataset.centered,
        centeredSlidesBounds: this.dataset.centeredMobile ? !!this.dataset.centeredMobile === 'true' : !!this.dataset.centered,
        centerInsufficientSlides: this.dataset.centeredMobile ? !!this.dataset.centeredMobile === 'true' : !!this.dataset.centered,
        slidesOffsetAfter: Number(this.dataset.mobileSlidesOffsetAfter) || 0,
        slidesOffsetBefore: Number(this.dataset.mobileSlidesOffsetBefore) || 0,
        navigation: {
          nextEl: this.querySelector('[data-next]'),
          prevEl: this.querySelector('[data-prev]'),
        },
        breakpoints: {
          // when window width is >= 768px
          768: {
            spaceBetween: Number(this.dataset.spaceBetween) || 2,
            slidesPerView: Number(this.dataset.slidesPerView) || 1,
            slidesPerGroup: this.dataset.slidesPerScroll ?  Number(this.dataset.slidesPerScroll) : (Number(this.dataset.slidesPerView) || 1),
            centeredSlides: !!this.dataset.centered,
            centeredSlidesBounds: !!this.dataset.centered,
            centerInsufficientSlides: !!this.dataset.centered,
            slidesOffsetAfter: Number(this.dataset.slidesOffsetAfter) || 0,
            slidesOffsetBefore: Number(this.dataset.slidesOffsetBefore) || 0,
            slidesPerGroup: Number(this.dataset.slidesPerGroup) || Number(this.dataset.slidesPerView) || 1,
          }
        }
      };

      this.slider = new Swiper(this, options);

      // Swiper's a11y module sets aria-live="polite" on the wrapper; flagged as
      // unnecessary noise by accessibility audit, so strip it after init/update.
      const wrapperEl = this.querySelector('.swiper-wrapper');
      wrapperEl?.removeAttribute('aria-live');
      this.slider.on('afterInit', () => wrapperEl?.removeAttribute('aria-live'));
      this.slider.on('slideChangeTransitionEnd', () => wrapperEl?.removeAttribute('aria-live'));

      window.addEventListener('coco-shuffle:product-updated', () => {
        if (this.querySelector('[data-product-images]')) {
          this.slider.update();
        }
      })
    }
  }
  customElements.define('swiper-carousel', Carousel);
}

/*
  EXAMPLE USAGE
  *
  Be sure to inlude the classes "swiper-wrapper" around all the slides and "swiper-slide" on each slide.
  Swiper uses these internally.
  *
  *
  *
  *
  <swiper-carousel
    data-space-between="0"
    data-slides-per-view="1"
    data-centered="true"
    data-centered-bounds="true"
    class=""
  >
    <div class="swiper-wrapper">
      {% for block in section.blocks %}
        <div class="swiper-slide">
            ..slide content
        </div>
      {% endfor %}
    </div>
  </swiper-carousel>
*/